import { isProduction } from 'config/environment';

const FILES = isProduction()
  ? 'https://files.eis24.me'
  : 'https://test-files.eis24.me';

export const GW_SERVICES_PREFIXES = {
  SIGNAL: 'signals/api/v1',
  AUTHORIZATION: 'auth/api/v1',
  DISPATCHER: 'disp/api/v4',
  C300: 'c300/api/v4',
  REQUEST: 'req',
  APPEALS: 'req',
  GIS: 'gis_service/api/v4',
  CHAT: 'chat', //TODO: пока не особо используется
  FILES,
  FILES_URL: `${FILES}/files`,
  FILES_GATEWAY: 'files',
  LKZH: 'lkzh/api/v4',
  AI: 'neuro_sphere',
} as const;
